// client\src\services\userService.js
import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "../utils/baseApi";

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const register = (username, password, role, status, whatsappNumber) => {
  return axios.post(
    `${API_URL}/users/register`,
    {
      username,
      password,
      role,
      status,
      whatsappNumber,
    },
    { headers: authHeader() }
  );
};

const getAllUsers = () => {
  return axios.get(`${API_URL}/users`, { headers: authHeader() });
};

const deleteUser = (userId) => {
  return axios.delete(`${API_URL}/users/${userId}`, { headers: authHeader() });
};

const updateUser = (userId, data) => {
  return axios.put(`${API_URL}/users/${userId}`, data, {
    headers: authHeader(),
  });
};

const userService = {
  register,
  getAllUsers,
  deleteUser,
  updateUser,
};

export default userService;
